import { c as _c } from "react/compiler-runtime";
import { Box } from '@chakra-ui/react';
import { useContentTrackContext } from '@src/components/sco/Education/ContentTrackContext';
import { ChatCtaStep } from '@src/components/sco/Education/ContentTrackStepDetail/Steps/ComponentSteps/ChatCtaStep';
import { CompanyProfileStep } from '@src/components/sco/Education/ContentTrackStepDetail/Steps/ComponentSteps/CompanyProfileStep';
import { IntroCallStep } from '@src/components/sco/Education/ContentTrackStepDetail/Steps/ComponentSteps/IntroCallStep';
import { OfficeHoursStep } from '@src/components/sco/Education/ContentTrackStepDetail/Steps/ComponentSteps/OfficeHoursStep';
import { UserProfileStep } from '@src/components/sco/Education/ContentTrackStepDetail/Steps/ComponentSteps/UserProfileStep';
import { WorkshopStep } from '@src/components/sco/Education/ContentTrackStepDetail/Steps/WorkshopStep';
import { ViewableTracker } from '@src/components/sco/ViewableTracker';
import { ContentTrackReactComponent, ContentTrackStep } from '@src/graphql-types';
import React from 'react';
const componentKeyMap = {
  TRACK_ACCOUNT_COMPANY_PROFILE: CompanyProfileStep,
  TRACK_ACCOUNT_INTRO_CALL: IntroCallStep,
  TRACK_ACCOUNT_USER_PROFILE: UserProfileStep,
  TRACK_CHAT_CTA: ChatCtaStep,
  TRACK_OFFICE_HOURS_LOOKUP: OfficeHoursStep,
  TRACK_WORKSHOP_LOOKUP: WorkshopStep
};
type ComponentStepProps = {
  component: ContentTrackReactComponent;
  contentTrackStep: ContentTrackStep;
};
export const ComponentStep = props => {
  const $ = _c(11);
  const trackContext = useContentTrackContext();
  let ComponentToRender = componentKeyMap[props.component.componentKey];
  if (!ComponentToRender) {
    let t0;
    if ($[0] !== props.component.componentKey) {
      t0 = () => <code>{"TBD Component Key: "}{props.component.componentKey}</code>;
      $[0] = props.component.componentKey;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    ComponentToRender = t0;
  }
  const t0 = trackContext.contentTrackEnrollment?.contentTrackEnrollmentId;
  let t1;
  if ($[2] !== ComponentToRender || $[3] !== props.component.propsAsJson || $[4] !== props.contentTrackStep) {
    t1 = <ComponentToRender contentTrackStep={props.contentTrackStep} {...props.component.propsAsJson} />;
    $[2] = ComponentToRender;
    $[3] = props.component.propsAsJson;
    $[4] = props.contentTrackStep;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== props.contentTrackStep.__typename || $[7] !== props.contentTrackStep.id || $[8] !== t0 || $[9] !== t1) {
    t2 = <Box width="full"><ViewableTracker parentId={t0} parentType="ContentTrackEnrollment" trackScrolling={true} viewableContext="component" viewableId={props.contentTrackStep.id} viewableType={props.contentTrackStep.__typename}>{t1}</ViewableTracker></Box>;
    $[6] = props.contentTrackStep.__typename;
    $[7] = props.contentTrackStep.id;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
};